import BlockedUsers from "./BlockedUsers";

export const routes = [
    {
        path: "/blocked",
        component: BlockedUsers,
        exact: true,
        showNav: true
    }
]